import { useCart } from "../context/CartContext";
import styles from "./CartDrawer.module.css";

const isImage = (src) => /\.(png|jpg|jpeg|webp)$/i.test(src);

export default function CartDrawer() {
  const { items, removeFromCart, total, count, cartOpen, setCartOpen } = useCart();

  const handleCheckout = () => {
    setCartOpen(false);
    window.location.href = "/checkout";
  };

  const handleWhatsAppOrder = () => {
    const itemList = items
      .map((i) => `• ${i.name} (${i.details.gemstone} · ${i.details.carat}) — LKR ${i.price.toLocaleString()}`)
      .join("\n");
    const message = `Hi! I'd like to place an order:\n\n${itemList}\n\nTotal: LKR ${total.toLocaleString()}`;
    const url = `https://wa.me/94765851400?text=${encodeURIComponent(message)}`;
    setCartOpen(false);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {cartOpen && (
        <div className={styles.backdrop} onClick={() => setCartOpen(false)} />
      )}

      <div className={`${styles.drawer} ${cartOpen ? styles.open : ""}`}>
        <div className={styles.header}>
          <h2 className={styles.title}>Your Cart <span>({count})</span></h2>
          <button className={styles.closeBtn} onClick={() => setCartOpen(false)}>✕</button>
        </div>

        <div className={styles.items}>
          {items.length === 0 ? (
            <div className={styles.empty}>
              <p>Your cart is empty</p>
              <button className={styles.shopBtn} onClick={() => setCartOpen(false)}>
                Continue Shopping
              </button>
            </div>
          ) : (
            items.map((item) => (
              <div key={item.id} className={styles.item}>
                {isImage(item.src)
                  ? <img src={item.src} alt={item.name} className={styles.thumb} style={{ objectFit: "cover" }} />
                  : <video src={item.src} className={styles.thumb} muted playsInline preload="metadata" />
                }
                <div className={styles.itemInfo}>
                  <p className={styles.itemName}>{item.name}</p>
                  <p className={styles.itemGem}>{item.details.gemstone} · {item.details.carat}</p>
                  <p className={styles.itemPrice}>LKR {item.price.toLocaleString()}</p>
                </div>
                <button className={styles.removeBtn} onClick={() => removeFromCart(item.id)}>✕</button>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className={styles.footer}>
            <div className={styles.totalRow}>
              <span>Total</span>
              <span className={styles.totalAmount}>LKR {total.toLocaleString()}</span>
            </div>

            {/* Primary — Checkout */}
            <button className={styles.checkoutBtn} onClick={handleCheckout}>
              Proceed to Checkout →
            </button>

            {/* Secondary — WhatsApp */}
            <button className={styles.whatsappBtn} onClick={handleWhatsAppOrder}>
              <img src="/whatsapp-logo.png" alt="WhatsApp" width={16} height={16} />
              Order via WhatsApp
            </button>

            <p className={styles.secure}>🔒 Secure payment via WebXPay</p>
          </div>
        )}
      </div>
    </>
  );
}
